import React, {Component, useState} from "react";
import MainButton from "../forms/Buttons";
import {Image, ProgressBar} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBookmark as faBookmarkSolid} from "@fortawesome/free-solid-svg-icons";
import {faBookmark as faBookmarkRegular} from "@fortawesome/free-regular-svg-icons";
import * as PropTypes from "prop-types";
import {Redirect, withRouter} from "react-router-dom";
import {addWatchlist} from "../../../store/actions/WatchlistActions";
import {connect} from "react-redux";
import {addCurrentFullProfile} from "../../../store/actions/FullProfileActions";
import {setFullProfilePlayerId} from "../../../store/actions/Dashboard/FullProfile/FullProfileActions";
import {gql, useQuery} from "@apollo/client";
import {useMutation} from "@apollo/react-hooks";
import {player} from "../../pages/dashboard/PlayerRows";
import AddToWatchListButton from "./AddToWatchListButton";

/**
 * Renders the value of the player profile card
 */
const ValueComponent = props => {
    return (
        <div>
            <div className="value"> {props.value} </div>
            <div className="title"> {props.title} </div>
        </div>
    );
};


/**
 * @class PlayerProfileCard
 * Get player profile card.
 */
class PlayerProfileCard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            redirect: null,
        }
    }

    render = () => {
        const {redirect} = this.state;
        if (redirect) {
            return <Redirect push to={redirect}/>;
        }
        return this.renderContent();
    };

    /**
     * Render player profile card content.
     * @returns {React.ReactNode}
     */
    renderContent = () => {
        return (
            <div className="player-profile-card">
                {this.renderImageContainer()}
                {this.renderScoreContainer()}
                <hr/>
                {this.renderValuesContainer()}
                <hr/>
                {this.renderButtonsContainer()}
                {this.renderIcon()}
            </div>
        );
    };

    /**
     * Render values of the player.
     * @returns {React.ReactNode}
     */
    renderValuesContainer = () => {
        const {value, wage} = this.props;

        return (
            <div className="values-container">
                <PlayerProfileCard.Value value={value} title="Value"/>
                <PlayerProfileCard.Value value={wage} title="Wage"/>
            </div>
        );
    };

    /**
     * Render Add watchlist buttons.
     * @returns {React.ReactNode}
     */
    renderWatchlistButton = () => {
        const {page} = this.props;

        // return page === 'talent-search' ? (
        //     <MainButton sm text="Add to watchlist" onClick={this.handleAddToWatchlistClick}/>
        // ) : null;
    };

    /**
     * Render navigation buttons.
     * @returns {React.ReactNode}
     */
    renderButtonsContainer = () => {
        const {id: playerId} = this.props;
        return (
            <div className="buttons-container">
                <MainButton sm text="View Full Profile" onClick={this.handleFullProfileClick}/>
                <AddToWatchListButton playerId={playerId}/>
                {/*{this.renderWatchlistButton()}*/}
            </div>
        );
    };

    /**
     * Render player avatar.
     * @returns {React.ReactNode}
     */
    renderImageContainer = () => {
        const {avatar} = this.props;

        return (
            <div className="image-container">
                <Image className="avatar" roundedCircle fluid src={avatar}/>
            </div>
        );
    };

    /**
     * Render player score.
     * @returns {React.ReactNode}
     */
    renderScoreContainer = () => {
        const {score} = this.props;
        return (
            <div className="score-container">
                <div className="progress-value"> {score} </div>
                <ProgressBar variant="success" now={score}/>
                <div className="title"> Over All Score</div>
            </div>
        );
    };

    /**
     * Render bookmark icon.
     * @returns {React.ReactNode}
     */
    renderIcon = () => {
        const {bookmarked, onBookmarkClick} = this.props;
        let icon = bookmarked ? faBookmarkSolid : faBookmarkRegular;
        return <FontAwesomeIcon className="icon" icon={icon} onClick={onBookmarkClick}/>
    };

    /**
     * Handle click event of full profile button.
     * @returns {void}
     */
    handleFullProfileClick = (event) => {
        const {page, data: row, id, setFullProfilePlayerId} = this.props;
        // todo: this must be base on route slag param full profile not getting the data from table
        this.props.addCurrentFullProfile(row);

        // setFullProfilePlayerId(id);
        this.setState({
            redirect: `${page}/full-profile/${id}`,
        });
    };


    static propTypes = {
        // The avatar that will appear in the top.
        avatar: PropTypes.string.isRequired,
        // The rate of the player.
        score: PropTypes.string.isRequired,
        // The wage of the player.
        value: PropTypes.string.isRequired,
        // The value of the player.
        wage: PropTypes.string.isRequired,
        // Determine if the player bookmarked.
        bookmarked: PropTypes.bool.isRequired,
        // Callback fire when click bookmark icon.
        onBookmarkClick: PropTypes.func.isRequired,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        addCurrentFullProfile: (current) => dispatch(addCurrentFullProfile(current)),
        setPlayerId: (playerId) => dispatch(setFullProfilePlayerId(playerId)),
        addWatchlist: (data) => dispatch(addWatchlist(data)),
    }
};

PlayerProfileCard.Value = ValueComponent;
export default connect(null, mapDispatchToProps)(withRouter(PlayerProfileCard));
